<template>
	<div class="pay">
		<img src="../../assets/brokerpay.png" style="width: 100%;" alt="">
		<div class="inputBox">
			<div>
				开通人手机号
			</div>
			<div>
				<input type="text" placeholder="请输入11位手机号">
			</div>
		</div>
		<div class="payBox">
			<div>
				请选择需要开通的服务：
			</div>
			<div class="selectBox" v-for="(item, index) in 3" :key="index" @click="">
				<img v-if="curIndex != index" src="../../assets/selectbg.png" class="bg" alt="">
				<img v-else-if="curIndex == index" src="../../assets/selectedbg.png" class="bg" alt="">
			</div>
			<img src="../../assets/button.png" style="width: 335px;" alt="">
			<div class="checkCon">
				<input type="checkbox">
				已同意<a href="https://www.zhimakaigong.com/#/arule">《芝麻招工超级经纪人合作协议》</a>及<a href="https://www.zhimakaigong.com/#/arule">《经纪
				人服务协议》</a>，购买商品为数字化内容服务，购买后不支持退款。
			</div>
		</div>
		<img src="../../assets/bdesc.png" alt="" style="margin: 40px auto;width: 335px;display: block;">
		<div style="height: 20px;"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		beforeCreate() {
			document.title = '经纪人购买'
		},
		data(){
			return{
				curIndex: 0
			}
		}
	}
</script>

<style scoped>
	.pay {
		color: #333;
	}

	.inputBox {
		font-size: 16px;
		margin: 10px auto;
		width: 335px;
		border-bottom: 1px solid #DDDDDD;
	}
	
	.inputBox div{
		margin-bottom: 10px;
	}

	.inputBox input {
		width: 100%;
		border: none;
		outline: none;
	}
	
	.payBox{
		margin: 20px auto;
		width: 335px;
	}
	.selectBox img{
		width: 335px;
		height: 42px;
	}
	.selectBox{
		position: relative;
		width: 335px;
		height: 42px;
		margin: 20px auto;
	}
	.selectBox .bg{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
	}
	input:checked{
		background-color: #BD7016;
	}
	.checkCon{
		margin: 20px 20px;
		font-size: 11px;
		color: #999999;
	}
	.checkCon a{
		color: #BD7016;
	}
</style>
